import { render, staticRenderFns } from "./AppUserMenu.vue?vue&type=template&id=700254f4"
import script from "./AppUserMenu.vue?vue&type=script&lang=js"
export * from "./AppUserMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports